import { render, staticRenderFns } from "./addcategory.vue?vue&type=template&id=59185286&scoped=true"
import script from "./addcategory.vue?vue&type=script&lang=js"
export * from "./addcategory.vue?vue&type=script&lang=js"
import style0 from "./addcategory.vue?vue&type=style&index=0&id=59185286&prod&scoped=true&lang=css"
import style1 from "./addcategory.vue?vue&type=style&index=1&id=59185286&prod&lang=scss&scoped=true"
import style2 from "./addcategory.vue?vue&type=style&index=2&id=59185286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59185286",
  null
  
)

export default component.exports